import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { SiteHeader } from "./components/SiteHeader";
import { SiteFooter } from "./components/SiteFooter";
import { ScrollManager } from "./components/ScrollManager";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { PayrollOperations } from "./pages/PayrollOperations";
import { HrTechnology } from "./pages/HrTechnology";
import { ProcessControls } from "./pages/ProcessControls";
import { Research } from "./pages/Research";
import { Ledger } from "./pages/Ledger";
import { Intelligence } from "./pages/Intelligence";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="28tw4wqgqei2x">
      <MotionConfig reducedMotion="user" data-id="element-1" data-mp="28te3lff7pdo5">
        <ScrollManager data-id="element-2" data-mp="28s2xva27hvue" />
        <div className="flex min-h-screen w-full flex-col bg-ivory" data-id="element-3" data-mp="23vkuadim43jn">
          <SiteHeader data-id="element-4" data-mp="23t8h0dnsuhcx" />
          <main className="flex-1" data-id="element-5" data-mp="3ik7g4ghnibqn">
            <Routes data-id="element-6" data-mp="3ij652c0mxp8x">
              <Route path="/" element={<Home data-id="element-8" data-mp="3ii4q3wgi0ilx" />} data-id="element-7" data-mp="3ijpc2xoqyt86" />
              <Route path="/services" element={<Services data-id="element-10" data-mp="3mk83iqmq9x9u" />} data-id="element-9" data-mp="3ml12v6jcxkhy" />
              <Route path="/payroll-operations" element={<PayrollOperations data-id="element-12" data-mp="3rbzmaezn6ypf" />} data-id="element-11" data-mp="3mjgclt42snpw" />
              <Route path="/hr-technology" element={<HrTechnology data-id="element-14" data-mp="5osn3wyp084" />} data-id="element-13" data-mp="3rd1all5o5hp3" />
              <Route path="/process-controls" element={<ProcessControls data-id="element-16" data-mp="82jf0klzq9v" />} data-id="element-15" data-mp="4wx1t3d72hu" />
              <Route path="/research" element={<Research data-id="element-18" data-mp="2zmemy5wtxg6g" />} data-id="element-17" data-mp="2zlldgx6hkckm" />
              <Route path="/intelligence" element={<Intelligence data-id="element-20" data-mp="33m5ck6amdq9e" />} data-id="element-19" data-mp="2zn66ujh2dpgw" />
              <Route path="/ledger" element={<Ledger data-id="element-22" data-mp="33oi3h8ycvayl" />} data-id="element-21" data-mp="33n6zp94wu37h" />
              <Route path="/about" element={<About data-id="element-24" data-mp="38l04bxqkep5n" />} data-id="element-23" data-mp="38l8hzruihyhw" />
              <Route path="/contact" element={<Contact data-id="element-26" data-mp="3dkl3o99ncziw" />} data-id="element-25" data-mp="38kgocmkh6au9" />
              <Route path="*" element={<Home data-id="element-28" data-mp="3dmfo7mh0apmg" />} data-id="element-27" data-mp="3dlw727z6k59h" />
            </Routes>
          </main>
          <SiteFooter data-id="element-29" data-mp="nw2e2bl1k0tq" />
        </div>
      </MotionConfig>
    </BrowserRouter>;
}